<template>
  <div :class="{ opened : value && animated }" class="hamburgerMenu py-1 px-2" @click="toggle">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
  </div>
</template>
<script>
export default {
  name: 'hamburger-menu',
  props: {
    value: {
      required: true,
      type: Boolean
    },
    animated: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
    }
  }
};
</script>
<style scoped>
.hamburgerMenu {
  display: inline-block;
  cursor: pointer;
  border: 1px solid #1B708D;
  border-radius: 0.4rem;
}

.bar1, .bar2, .bar3 {
  width: 1.5rem;
  height: 0.2rem;
  background-color: #3396B8;
  margin: 0.3rem 0;
  transition: 0.4s;
}

.opened .bar1 {
  -webkit-transform: rotate(-45deg) translate(-0.35rem, 0.35rem);
  transform: rotate(-45deg) translate(-0.35rem, 0.35rem);
}

.opened .bar2 {
  opacity: 0;
}

.opened .bar3 {
  -webkit-transform: rotate(45deg) translate(-0.35rem, -0.35rem);
  transform: rotate(45deg) translate(-0.35rem, -0.35rem);
}
</style>